import moment from 'moment'
import {
  SOCKET_Endpoint,
  SOCKET_NewPeerState,
  SOCKET_PJSIPChannel,
  PREV_CALL_INDEX,
  NEXT_CALL_INDEX,
  RESET_CALL_INDEX,
  PREV_CALL_INDEX_OPERADOR,
  NEXT_CALL_INDEX_OPERADOR,
  UPDATE_ENDPOINT,
  SOCKET_DeleteEndpoint,
  SOCKET_NewAgent,
  SOCKET_UpdateAgentStatus,
  SOCKET_RemoveAgent,
  SOCKET_NewQueueCall,
  SOCKET_CallOnWait,
  SOCKET_callsMonitorOperador,
  SOCKET_ProtocolNew,
  SOCKET_ProtocolOld,
  SOCKET_RemoveCallOnWait,
  SOCKET_ClickToCall,
  SOCKET_Hangup,
  SOCKET_LinkedIdEnd,
  SOCKET_Connect,
  SOCKET_FullyBooted,
  SOCKET_HistoryOld,
  SOCKET_HistoryNew,
  GET_ALL_PEERS,
  SOCKET_EndListAgent,
  SOCKET_NewQueueCallOnConnect,
  SOCKET_CallOnWaitOnConnect,
  SOCKET_UpdateAgentStatusOnConnect,
  SOCKET_NewAgentOnConnect,
  SOCKET_PJSIPChannelOnConnect,
  SOCKET_EndpointOnConnect,
} from './mutation-types'

function start(started, ramaisMonitor, callsOnWait) {
  started = setInterval(universalClockRunning, 1000, [ramaisMonitor, callsOnWait])
}

function universalClockRunning(keys) {
  let ramaisMonitor = keys[0]
  let callsOnWait = keys[1]
  // if(keys[2] != true){
  //   ramaisMonitor.forEach(ramal => {
  //     // if (ramal.updatedAt) {
  //     //   ramal.time = ramal.time
  //     // }
  //     console.log(ramal)
  //   })
  //   //   if (typeof ramal.channels !== 'undefined' && ramal.channels.length > 0) {
  //   //     ramal.channels.forEach(channel => {
  //   //       // channel.time = calculaTempo(channel.updatedAt)
  //   //     })
  //   //   }
  //   // })
  
  //   // ramaisMonitor.splice(0, 1, ramaisMonitor[0])
  
  //   // if (typeof callsOnWait !== 'undefined' && callsOnWait.length > 0) {
  //   //   callsOnWait.forEach(callWaiting => {
  //   //     callWaiting.time = calculaTempo(callWaiting.updatedAt)
  //   //   })
  //   //   callsOnWait.splice(0, 1, callsOnWait[0])
  //   // }
  //   keys[2] = true
  // }else{
    ramaisMonitor.forEach(ramal => {
      if (ramal.time) {
        ramal.time = calculaTempoEvento(ramal.time)
      }
  
      if (typeof ramal.channels !== 'undefined' && ramal.channels.length > 0) {
        ramal.channels.forEach(channel => {
           channel.time = calculaTempoEvento(channel.time)
        })
      }
    })
  
    ramaisMonitor.splice(0, 1, ramaisMonitor[0])
  
    if (typeof callsOnWait !== 'undefined' && callsOnWait.length > 0) {
      callsOnWait.forEach(callWaiting => {
        callWaiting.time = calculaTempoEvento(callWaiting.time)
      })
      callsOnWait.splice(0, 1, callsOnWait[0])
    }
  // }
}

function calculaTempoEvento(time) {
  let stringTempo = ''
  // if(/(?:23):(?:[0-5]\d):(?:[0-5]\d)/.test(time)){
  //   stringTempo = `${moment(time, 'HH:mm:ss').subtract(23, 'hours').format('HH:mm:ss')}`
  // }
  // else if(time === '22:59:59'){
  //   stringTempo = `${moment().startOf('day').format('HH:mm:ss')}`
  // }else{
    stringTempo = `${moment(time, 'HH:mm:ss').add(1,'s').format('HH:mm:ss')}`
  // }

  return stringTempo
}


// function calculaTempo(updatedAt) {
//   let now = moment().format('YYYY-MM-DD HH:mm:ss')
//   let tempoTotal = moment(now).diff(moment(updatedAt))
//   let stringTempo = `${moment.utc(tempoTotal).format('HH:mm:ss')}`
  
//   if (stringTempo === '23:59:59' ) {
//     stringTempo = '+24:00:00'
//   }

//   return stringTempo
// }

export default {

  //Eventos do Gerados ao iniciar a conexão
  //=========================================================================

  [SOCKET_NewQueueCallOnConnect]: (state, data) => {
    const indexRamal = state.ramaisMonitor.findIndex(ramal => ramal.deviceId === data.peer)

    if (indexRamal !== -1) {
      if (state.ramaisMonitor[indexRamal].queueEnters.findIndex(channel => channel.linkedId === data.linkedId) === -1) {
        state.ramaisMonitor[indexRamal].queueEnters.push({ linkedId: data.linkedId, queue: data.idQueue })
      }
    }
  },

  [SOCKET_CallOnWaitOnConnect]: (state, data) => {
    const indexCallWaiting = state.callsOnWait.findIndex(
      callWaiting => callWaiting.linkedId === data.linkedId || callWaiting.origin === data.origin
    )

    if (indexCallWaiting === -1) {
      state.callsOnWait.push({
        linkedId: data.linkedId,
        origin: data.origin,
        idQueue: data.idQueue,
        updatedAt: data.updatedAt,
        time: data.time,
        started: null,
      })
    }
  },

  [SOCKET_UpdateAgentStatusOnConnect]: (state, data) => {
    const indexOperador = state.ramaisMonitor.findIndex(ramalMonitor => ramalMonitor.agent === data.operator)

    if (indexOperador !== -1) {
      state.ramaisMonitor[indexOperador].paused = data.paused
      state.ramaisMonitor[indexOperador].reason = data.reason
      state.ramaisMonitor[indexOperador].updatedAt = data.updatedAt
      state.ramaisMonitor[indexOperador].time = data.time
    }

    state.ramaisMonitor.splice(0, 1, state.ramaisMonitor[0])
  },


  [SOCKET_NewAgentOnConnect]: (state, newAgent) => {
    const operatorIndex = state.ramaisMonitor.findIndex(ramalMonitor => ramalMonitor.deviceId === newAgent.peer)
    if (operatorIndex !== -1) {
      state.ramaisMonitor[operatorIndex].agent = `${newAgent.operatorName}-${newAgent.operatorCode}`
      state.ramaisMonitor[operatorIndex].paused = '0'
      state.ramaisMonitor[operatorIndex].reason = ''
      state.ramaisMonitor[operatorIndex].updatedAt = newAgent.updatedAt
      state.ramaisMonitor[operatorIndex].time = newAgent.time

      if (typeof state.ramaisMonitor[operatorIndex].started === 'undefined') {
        state.ramaisMonitor[operatorIndex].started = null
      }

      if (!state.ramaisMonitor[operatorIndex].arrayQueues) {
        state.ramaisMonitor[operatorIndex].arrayQueues = [{ queue: newAgent.idQueue, penalty: newAgent.penalty }]
      } else {
        const indexQueue = state.ramaisMonitor[operatorIndex].arrayQueues.findIndex(
          queue => queue.queue === newAgent.idQueue
        )

        if (indexQueue === -1) {
          state.ramaisMonitor[operatorIndex].arrayQueues.push({ queue: newAgent.idQueue, penalty: newAgent.penalty })
        }
      }
    }
  },

  [SOCKET_PJSIPChannelOnConnect]: (state, pjsipchannel) => {
    if (typeof pjsipchannel.peer.split('.')[1] === 'undefined') {
      const indexRamal = state.ramaisMonitor.findIndex(ramal => ramal.deviceId === pjsipchannel.peer)

      if (indexRamal !== -1) {
        const indexClickToCall = state.ramaisMonitor[indexRamal].channels.findIndex(
          channel => channel.linkedId === pjsipchannel.linkedId && channel.event === 'ClickToCall'
        )

        if (indexClickToCall !== -1) {
          if (pjsipchannel.status === 'RINGING') {
            state.ramaisMonitor[indexRamal].channels[
              indexClickToCall
            ].linkedId_uniqueId = `${pjsipchannel.linkedId}_${pjsipchannel.uniqueId}`
          } else if (pjsipchannel.status === 'UP') {
            state.ramaisMonitor[indexRamal].channels[indexClickToCall].state = pjsipchannel.status
            state.ramaisMonitor[indexRamal].channels[indexClickToCall].updatedAt = pjsipchannel.updatedAt
            state.ramaisMonitor[indexRamal].channels[indexClickToCall].channel = pjsipchannel.channel
            state.ramaisMonitor[indexRamal].channels[indexClickToCall].time = pjsipchannel.time
          }
        } else {
          const indexChannel = state.ramaisMonitor[indexRamal].channels.findIndex(
            channel => channel.linkedId_uniqueId === `${pjsipchannel.linkedId}_${pjsipchannel.uniqueId}`
          )

          const indexQueueEnter = state.ramaisMonitor[indexRamal].queueEnters.findIndex(
            queue => queue.linkedId === pjsipchannel.linkedId
          )

          if (indexChannel !== -1) {
            state.ramaisMonitor[indexRamal].channels[indexChannel].state = pjsipchannel.status
            state.ramaisMonitor[indexRamal].channels[indexChannel].phoneNumber = pjsipchannel.phoneNumber
            state.ramaisMonitor[indexRamal].channels[indexChannel].io = pjsipchannel.io
            state.ramaisMonitor[indexRamal].channels[indexChannel].updatedAt = pjsipchannel.updatedAt
            state.ramaisMonitor[indexRamal].channels[indexChannel].channel = pjsipchannel.channel
            state.ramaisMonitor[indexRamal].channels[indexChannel].time = pjsipchannel.time

            if (
              indexQueueEnter !== -1 &&
              typeof state.ramaisMonitor[indexRamal].channels[indexChannel].queue === 'undefined'
            ) {
              state.ramaisMonitor[indexRamal].channels[indexChannel].queue =
                state.ramaisMonitor[indexRamal].queueEnters[indexQueueEnter].queue
            }
          } else {
            if (indexQueueEnter === -1) {
              state.ramaisMonitor[indexRamal].channels.push({
                linkedId_uniqueId: `${pjsipchannel.linkedId}_${pjsipchannel.uniqueId}`,
                channel: pjsipchannel.channel,
                state: pjsipchannel.status,
                phoneNumber: pjsipchannel.phoneNumber,
                io: pjsipchannel.io,
                updatedAt: pjsipchannel.updatedAt,
                time: pjsipchannel.time,
              })
            } else {
              state.ramaisMonitor[indexRamal].channels.push({
                linkedId_uniqueId: `${pjsipchannel.linkedId}_${pjsipchannel.uniqueId}`,
                channel: pjsipchannel.channel,
                state: pjsipchannel.status,
                phoneNumber: pjsipchannel.phoneNumber,
                io: pjsipchannel.io,
                updatedAt: pjsipchannel.updatedAt,
                time: pjsipchannel.time,
                queue: state.ramaisMonitor[indexRamal].queueEnters[indexQueueEnter].queue,
              })
            }
          }
        }
      }
    }
  },

  [SOCKET_EndpointOnConnect]: (state, endpoint) => {
    const copiaRamaisMonitor = [...state.ramaisMonitor]
    const numberVerify = copiaRamaisMonitor.findIndex(ramal => ramal.peer === endpoint.peer)

    if (numberVerify === -1) {
      state.ramaisMonitor.push({
        peer: endpoint.peer,
        updatedAt: endpoint.updatedAt,
        time: endpoint.time,
        deviceId: endpoint.deviceId,
        user: endpoint.user,
        isNotRegistered: endpoint.isNotRegistered,
        callIndex: 0,
        callIndexOperador: 0,
        channels: [],
        queueEnters: [],
      })
    }

    state.ramaisMonitor.sort((a, b) => {
      if (a.deviceId > b.deviceId) {
        return 1
      }
      if (a.deviceId < b.deviceId) {
        return -1
      }
      return 0
    })
  },


  //Eventos do connect porém
  //====================================================================


  [SOCKET_NewQueueCall]: (state, data) => {
    const indexRamal = state.ramaisMonitor.findIndex(ramal => ramal.deviceId === data.peer)

    if (indexRamal !== -1) {
      if (state.ramaisMonitor[indexRamal].queueEnters.findIndex(channel => channel.linkedId === data.linkedId) === -1) {
        state.ramaisMonitor[indexRamal].queueEnters.push({ linkedId: data.linkedId, queue: data.idQueue })
      }
    }
  },

  [SOCKET_CallOnWait]: (state, data) => {
    const indexCallWaiting = state.callsOnWait.findIndex(
      callWaiting => callWaiting.linkedId === data.linkedId || callWaiting.origin === data.origin
    )

    if (indexCallWaiting === -1) {
      state.callsOnWait.push({
        linkedId: data.linkedId,
        origin: data.origin,
        idQueue: data.idQueue,
        updatedAt: data.updatedAt,
        time:  calculaTempoEvento("00:00:00"),
        started: null,
      })
    }
  },

  [SOCKET_UpdateAgentStatus]: (state, data) => {
    const indexOperador = state.ramaisMonitor.findIndex(ramalMonitor => ramalMonitor.agent === data.operator)

    if (indexOperador !== -1) {
      state.ramaisMonitor[indexOperador].paused = data.paused
      state.ramaisMonitor[indexOperador].reason = data.reason
      state.ramaisMonitor[indexOperador].updatedAt = data.updatedAt
      state.ramaisMonitor[indexOperador].time =  calculaTempoEvento("00:00:00")
    }

    state.ramaisMonitor.splice(0, 1, state.ramaisMonitor[0])
  },


  [SOCKET_NewAgent]: (state, newAgent) => {
    const operatorIndex = state.ramaisMonitor.findIndex(ramalMonitor => ramalMonitor.deviceId === newAgent.peer)
    if (operatorIndex !== -1) {
      state.ramaisMonitor[operatorIndex].agent = `${newAgent.operatorName}-${newAgent.operatorCode}`
      state.ramaisMonitor[operatorIndex].paused = '0'
      state.ramaisMonitor[operatorIndex].reason = ''
      state.ramaisMonitor[operatorIndex].updatedAt = newAgent.updatedAt
      state.ramaisMonitor[operatorIndex].time =  calculaTempoEvento("00:00:00")

      if (typeof state.ramaisMonitor[operatorIndex].started === 'undefined') {
        state.ramaisMonitor[operatorIndex].started = null
      }

      if (!state.ramaisMonitor[operatorIndex].arrayQueues) {
        state.ramaisMonitor[operatorIndex].arrayQueues = [{ queue: newAgent.idQueue, penalty: newAgent.penalty }]
      } else {
        const indexQueue = state.ramaisMonitor[operatorIndex].arrayQueues.findIndex(
          queue => queue.queue === newAgent.idQueue
        )

        if (indexQueue === -1) {
          state.ramaisMonitor[operatorIndex].arrayQueues.push({ queue: newAgent.idQueue, penalty: newAgent.penalty })
        }
      }
    }
  },

  [SOCKET_PJSIPChannel]: (state, pjsipchannel) => {
    if (typeof pjsipchannel.peer.split('.')[1] === 'undefined') {
      const indexRamal = state.ramaisMonitor.findIndex(ramal => ramal.deviceId === pjsipchannel.peer)

      if (indexRamal !== -1) {
        const indexClickToCall = state.ramaisMonitor[indexRamal].channels.findIndex(
          channel => channel.linkedId === pjsipchannel.linkedId && channel.event === 'ClickToCall'
        )

        if (indexClickToCall !== -1) {
          if (pjsipchannel.status === 'RINGING') {
            state.ramaisMonitor[indexRamal].channels[
              indexClickToCall
            ].linkedId_uniqueId = `${pjsipchannel.linkedId}_${pjsipchannel.uniqueId}`
          } else if (pjsipchannel.status === 'UP') {
            state.ramaisMonitor[indexRamal].channels[indexClickToCall].state = pjsipchannel.status
            state.ramaisMonitor[indexRamal].channels[indexClickToCall].updatedAt = pjsipchannel.updatedAt
            state.ramaisMonitor[indexRamal].channels[indexClickToCall].channel = pjsipchannel.channel
            state.ramaisMonitor[indexRamal].channels[indexClickToCall].time =  calculaTempoEvento("00:00:00")
          }
        } else {
          const indexChannel = state.ramaisMonitor[indexRamal].channels.findIndex(
            channel => channel.linkedId_uniqueId === `${pjsipchannel.linkedId}_${pjsipchannel.uniqueId}`
          )

          const indexQueueEnter = state.ramaisMonitor[indexRamal].queueEnters.findIndex(
            queue => queue.linkedId === pjsipchannel.linkedId
          )

          if (indexChannel !== -1) {
            state.ramaisMonitor[indexRamal].channels[indexChannel].state = pjsipchannel.status
            state.ramaisMonitor[indexRamal].channels[indexChannel].phoneNumber = pjsipchannel.phoneNumber
            state.ramaisMonitor[indexRamal].channels[indexChannel].io = pjsipchannel.io
            state.ramaisMonitor[indexRamal].channels[indexChannel].updatedAt = pjsipchannel.updatedAt
            state.ramaisMonitor[indexRamal].channels[indexChannel].channel = pjsipchannel.channel
            state.ramaisMonitor[indexRamal].channels[indexChannel].time =  calculaTempoEvento("00:00:00")

            if (
              indexQueueEnter !== -1 &&
              typeof state.ramaisMonitor[indexRamal].channels[indexChannel].queue === 'undefined'
            ) {
              state.ramaisMonitor[indexRamal].channels[indexChannel].queue =
                state.ramaisMonitor[indexRamal].queueEnters[indexQueueEnter].queue
            }
          } else {
            if (indexQueueEnter === -1) {
              state.ramaisMonitor[indexRamal].channels.push({
                linkedId_uniqueId: `${pjsipchannel.linkedId}_${pjsipchannel.uniqueId}`,
                channel: pjsipchannel.channel,
                state: pjsipchannel.status,
                phoneNumber: pjsipchannel.phoneNumber,
                io: pjsipchannel.io,
                updatedAt: pjsipchannel.updatedAt,
                time: calculaTempoEvento("00:00:00"),
              })
            } else {
              state.ramaisMonitor[indexRamal].channels.push({
                linkedId_uniqueId: `${pjsipchannel.linkedId}_${pjsipchannel.uniqueId}`,
                channel: pjsipchannel.channel,
                state: pjsipchannel.status,
                phoneNumber: pjsipchannel.phoneNumber,
                io: pjsipchannel.io,
                updatedAt: pjsipchannel.updatedAt,
                time: calculaTempoEvento("00:00:00"),
                queue: state.ramaisMonitor[indexRamal].queueEnters[indexQueueEnter].queue,
              })
            }
          }
        }
      }
    }
  },

  [SOCKET_Endpoint]: (state, endpoint) => {
    const copiaRamaisMonitor = [...state.ramaisMonitor]
    const numberVerify = copiaRamaisMonitor.findIndex(ramal => ramal.peer === endpoint.peer)

    if (numberVerify === -1) {
      state.ramaisMonitor.push({
        peer: endpoint.peer,
        updatedAt: endpoint.updatedAt,
        time:  calculaTempoEvento("00:00:00"),
        deviceId: endpoint.deviceId,
        user: endpoint.user,
        isNotRegistered: endpoint.isNotRegistered,
        callIndex: 0,
        callIndexOperador: 0,
        channels: [],
        queueEnters: [],
      })
    }

    state.ramaisMonitor.sort((a, b) => {
      if (a.deviceId > b.deviceId) {
        return 1
      }
      if (a.deviceId < b.deviceId) {
        return -1
      }
      return 0
    })
  },



  //Outros eventos 
  //====================================================================

  
  [SOCKET_FullyBooted]: state => {
    state.ramaisMonitor.forEach(ramal => {
      ramal.channels.splice(0)
    })

    state.callsOnWait.splice(0)
    if (!state.started) {
      start(state.started, state.ramaisMonitor, state.callsOnWait)
    }
  },

  [SOCKET_Connect]: state => {
    state.ramaisMonitor.forEach(ramal => {
      ramal.channels.splice(0)
    })

    state.callsOnWait.splice(0)
    if (!state.started) {
      start(state.started, state.ramaisMonitor, state.callsOnWait)
    }
  },

  [SOCKET_RemoveAgent]: (state, data) => {
    const indexOperador = state.ramaisMonitor.findIndex(ramalMonitor => ramalMonitor.agent === data.operatorCode)

    if (indexOperador !== -1) {
      const indexQueue = state.ramaisMonitor[indexOperador].arrayQueues.findIndex(queue => queue.queue === data.idQueue)
      if (indexQueue !== -1) {
        state.ramaisMonitor[indexOperador].arrayQueues.splice(indexQueue, 1)
        if (state.ramaisMonitor[indexOperador].arrayQueues.length === 0) {
          delete state.ramaisMonitor[indexOperador].agent
          delete state.ramaisMonitor[indexOperador].started
          state.ramaisMonitor[indexOperador].time = calculaTempoEvento("00:00:00")
          delete state.ramaisMonitor[indexOperador].paused
          delete state.ramaisMonitor[indexOperador].reason
          delete state.ramaisMonitor[indexOperador].arrayQueues
        }
      }
    }

    state.ramaisMonitor.splice(0, 1, state.ramaisMonitor[0])
  },

 

  [SOCKET_callsMonitorOperador]: (state, data) => {
    if(data){
      state.callsMonitorOperador = data
    } else {
      state.callsMonitorOperador = []
    }
  },

  [SOCKET_ProtocolNew]: (state, data) => {
    state.protocoloChamadas.push(data)
  },

  [SOCKET_ProtocolOld]: (state, data) => {
    state.protocoloChamadas = data
  },

  [SOCKET_RemoveCallOnWait]: (state, data) => {
    const indexCallWaiting = state.callsOnWait.findIndex(callWaiting => callWaiting.linkedId === data.linkedId)

    if (indexCallWaiting !== -1) {
      clearInterval(state.callsOnWait[indexCallWaiting].started)
      state.callsOnWait.splice(indexCallWaiting, 1)
    }
  },

  //Atualiza o estado do ramal
  [SOCKET_NewPeerState]: (state, endpoint) => {
    const indexRamal = state.ramaisMonitor.findIndex(ramal => ramal.deviceId === endpoint.deviceId)

    if (indexRamal !== -1) {
      state.ramaisMonitor[indexRamal].isNotRegistered = endpoint.isNotRegistered
      state.ramaisMonitor[indexRamal].time = calculaTempoEvento("00:00:00")
    }

    state.ramaisMonitor.splice(0, 1, state.ramaisMonitor[0])
  },

  [SOCKET_ClickToCall]: (state, data) => {
    const indexRamal = state.ramaisMonitor.findIndex(ramal => ramal.deviceId === data.peer)

    if (indexRamal !== -1) {
      state.ramaisMonitor[indexRamal].channels.push({
        linkedId: data.linkedId,
        phoneNumber: data.phoneNumber,
        time: calculaTempoEvento("00:00:00"),
        state: 'RING',
        io: 'outgoing',
        event: 'ClickToCall',
        started: null,
      })
    }

    state.ramaisMonitor.splice(0, 1, state.ramaisMonitor[0])
  },

  

  [SOCKET_Hangup]: (state, data) => {
    const indexRamal = state.ramaisMonitor.findIndex(ramal => ramal.deviceId === data.peer)

    if (indexRamal !== -1) {
      const indexChannel = state.ramaisMonitor[indexRamal].channels.findIndex(
        channel => channel.linkedId_uniqueId === `${data.linkedId}_${data.uniqueId}`
      )

      if (indexChannel !== -1) {
        state.ramaisMonitor[indexRamal].updatedAt = data.updatedAt
        state.ramaisMonitor[indexRamal].time = calculaTempoEvento("00:00:00")
        state.ramaisMonitor[indexRamal].callIndex = 0
        state.ramaisMonitor[indexRamal].callIndexOperador = 0
        state.ramaisMonitor[indexRamal].channels.splice(indexChannel, 1)
      }

      const indexQueueEnter = state.ramaisMonitor[indexRamal].queueEnters.findIndex(
        queue => queue.linkedId === data.linkedId
      )
      if (state.ramaisMonitor[indexRamal].channels.length === 0) {
        if (indexQueueEnter !== -1) {
          state.ramaisMonitor[indexRamal].queueEnters.splice(indexQueueEnter, 1)
        }
      } else {
        let haveCallByLinkedId = false
        state.ramaisMonitor[indexRamal].channels.forEach(channel => {
          if (
            typeof channel.queue !== 'undefined' &&
            channel.queue === state.ramaisMonitor[indexRamal].queueEnters[indexQueueEnter].queue
          ) {
            haveCallByLinkedId = true
          }
        })

        if (!haveCallByLinkedId) {
          state.ramaisMonitor[indexRamal].queueEnters.splice(indexQueueEnter, 1)
        }
      }
    }
  },

  [SOCKET_LinkedIdEnd]: (state, data) => {
    const indexRamal = state.ramaisMonitor.findIndex(ramal => ramal.deviceId === data.peer)
    if (indexRamal !== -1) {
      if (state.ramaisMonitor[indexRamal].channels && state.ramaisMonitor[indexRamal].channels.length > 0) {
        const indexChannel = state.ramaisMonitor[indexRamal].channels.findIndex(
          channel => channel.linkedId_uniqueId.split('_')[0] === data.linkedId
        )
        if (indexChannel !== -1) {
          state.ramaisMonitor[indexRamal].updatedAt = data.updatedAt
          state.ramaisMonitor[indexRamal].callIndex = 0
          state.ramaisMonitor[indexRamal].callIndexOperador = 0
          state.ramaisMonitor[indexRamal].channels.splice(indexChannel, 1)
        }

        const indexQueueEnter = state.ramaisMonitor[indexRamal].queueEnters.findIndex(
          queue => queue.linkedId === data.linkedId
        )
        if (indexQueueEnter !== -1) {
          state.ramaisMonitor[indexRamal].queueEnters.splice(indexQueueEnter, 1)
        }

        let haveCallByLinkedId = false
        state.ramaisMonitor[indexRamal].channels.forEach(channel => {
          if (
            typeof channel.queue !== 'undefined' &&
            channel.queue === state.ramaisMonitor[indexRamal].queueEnters[indexQueueEnter].queue
          ) {
            haveCallByLinkedId = true
          }
        })

        if (!haveCallByLinkedId) {
          state.ramaisMonitor[indexRamal].queueEnters.splice(indexQueueEnter, 1)
        }
      }
    }
    for(let i = state.protocoloChamadas.length-1 ; i >= 0; i--){
      if(state.protocoloChamadas[i].linkedId === data.linkedId){
        state.protocoloChamadas.splice(i,1);
      }
    }
  },

  [PREV_CALL_INDEX]: (state, deviceId) => {
    const indexRamal = state.ramaisMonitor.findIndex(ramal => ramal.deviceId === deviceId)
    if (indexRamal !== -1) {
      if (state.ramaisMonitor[indexRamal].callIndex - 1 < 0) {
        state.ramaisMonitor[indexRamal].callIndex = state.ramaisMonitor[indexRamal].channels.length - 1
      } else {
        state.ramaisMonitor[indexRamal].callIndex--
      }
      state.ramaisMonitor.splice(indexRamal, 1, state.ramaisMonitor[indexRamal])
    }
  },

  [PREV_CALL_INDEX_OPERADOR]: (state, deviceId) => {
    const indexRamal = state.ramaisMonitor.findIndex(ramal => ramal.deviceId === deviceId)
    if (indexRamal !== -1) {
      if (state.ramaisMonitor[indexRamal].callIndexOperador - 1 < 0) {
        state.ramaisMonitor[indexRamal].callIndexOperador = state.ramaisMonitor[indexRamal].channels.length - 1
      } else {
        state.ramaisMonitor[indexRamal].callIndexOperador--
      }
      state.ramaisMonitor.splice(indexRamal, 1, state.ramaisMonitor[indexRamal])
    }
  },

  [NEXT_CALL_INDEX]: (state, deviceId) => {
    const indexRamal = state.ramaisMonitor.findIndex(ramal => ramal.deviceId === deviceId)
    if (indexRamal !== -1) {
      if (state.ramaisMonitor[indexRamal].callIndex + 1 > state.ramaisMonitor[indexRamal].channels.length - 1) {
        state.ramaisMonitor[indexRamal].callIndex = 0
      } else {
        state.ramaisMonitor[indexRamal].callIndex++
      }
      state.ramaisMonitor.splice(indexRamal, 1, state.ramaisMonitor[indexRamal])
    }
  },

  [NEXT_CALL_INDEX_OPERADOR]: (state, deviceId) => {
    const indexRamal = state.ramaisMonitor.findIndex(ramal => ramal.deviceId === deviceId)
    if (indexRamal !== -1) {
      if (state.ramaisMonitor[indexRamal].callIndexOperador + 1 > state.ramaisMonitor[indexRamal].channels.length - 1) {
        state.ramaisMonitor[indexRamal].callIndexOperador = 0
      } else {
        state.ramaisMonitor[indexRamal].callIndexOperador++
      }
      state.ramaisMonitor.splice(indexRamal, 1, state.ramaisMonitor[indexRamal])
    }
  },

  [RESET_CALL_INDEX]: (state, key) => {
    state.ramaisMonitor[key].callIndex = 0
    state.ramaisMonitor.splice(key, 1, state.ramaisMonitor[key])
  },

  [UPDATE_ENDPOINT]: (state, data) => {
    const indexRamal = state.ramaisMonitor.findIndex(ramal => ramal.deviceId === data.deviceId)
    if (indexRamal !== -1) {
      state.ramaisMonitor[indexRamal].user = data.user
      state.ramaisMonitor.splice(indexRamal, 1, state.ramaisMonitor[indexRamal])
    }
  },

  [SOCKET_DeleteEndpoint]: (state, data) => {
    const indexRamal = state.ramaisMonitor.findIndex(ramal => ramal.deviceId === data.deviceId)

    if (indexRamal !== -1) {
      state.ramaisMonitor.splice(indexRamal, 1)
    }
  },
  [GET_ALL_PEERS]: (state, ramais) => {
    state.ramais = ramais
  },
  [SOCKET_HistoryOld]:(state, data)=>{
    state.history = data
  },
  [SOCKET_HistoryNew]:(state, data)=>{  
    (state.history[data.operatorCode] = state.history[data.operatorCode] || []).push(data);
  },
  [SOCKET_EndListAgent]:(state, data)=>{  
    state.endListAgent = data.EndListAgent;
  },
}
